import { Affiliate } from "@/types";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import {
  sanitizeFieldRestProps,
  useGetPathForRecord,
  useRecordContext,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { ReferralHitsCellProps } from "./referral-hits-cell.types";
import { Girl, Man } from "@mui/icons-material";

const ReferralHitsCell: FC<ReferralHitsCellProps> = ({
  resourceName,
  ...props
}) => {
  const navigate = useNavigate();
  const user = useRecordContext<Affiliate>();
  const recordPath = useGetPathForRecord({
    record: user,
    resource: resourceName,
  });

  const onRowClick = () => {
    navigate(recordPath || "", {
      state: { _scrollToTop: true },
    });
  };

  if (!user) return null;

  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{ cursor: "pointer" }}
      alignItems={"center"}
      onClick={onRowClick}
      {...sanitizeFieldRestProps(props)}
    >
      <Stack direction={"row"} spacing={1}>
        <Man />
        <Typography component="span" variant="body2" noWrap={true}>
          {user.referralsCounts.alpha}
        </Typography>
      </Stack>
      <Stack direction={"row"} spacing={1}>
        <Girl />
        <Typography component="span" variant="body2" noWrap={true}>
          {user.referralsCounts.muse}
        </Typography>
      </Stack>
    </Stack>
  );
};

export { ReferralHitsCell };
